import angular from 'angular';
import view from './view.html';

/* @ngInject */
export default function () {
	const ROOT_NODE_PARENT_IDENTIFIER = '#';

	const setupConditionalSelect = ($scope) => {
		if ($scope.conditionalSelect && $scope.conditionalSelectType) {
			$scope.config.plugins.push('conditionalselect');

			let selectableTypes = $scope.conditionalSelectType;

			if (!Array.isArray(selectableTypes)) {
				selectableTypes = [
					selectableTypes,
				];
			}

			$scope.config.conditionalselect = (node) => {
				return selectableTypes.indexOf(node.type) !== -1;
			};
		}
	};

	const setupContextMenu = ($scope) => {
		if ($scope.contextMenu && $scope.contextMenuItems) {
			$scope.config.plugins.push('contextmenu');

			$scope.config.contextmenu = {
				items: () => {
					let items = {};

					angular.forEach($scope.contextMenuItems, (item) => {
						items[item] = {
							label:            item,
							action:           (node) => {
								if ($scope.onContextMenuItemAction) {
									$scope.onContextMenuItemAction(item, $scope.selectedNodeId);
								}
							},
							separator_before: false,
							separator_after:  false,
						};
					});

					return items;
				},
			};
		}
	};

	const setupDragDrop = ($scope) => {
		if ($scope.dragDrop) {
			$scope.config.plugins.push('dnd');

			$scope.events['move_node'] = $scope.moveNodeEvent;
		}
	};

	const setup = ($scope) => {
		$scope.ready = false;

		$scope.config = {
			core:    {
				check_callback: () => {
					return true;
				},
			},
			plugins: [
				'types',
				'sort',
			],
			types:   {
				directory: {
					icon: 'fa fa-fw fa-folder m-r-xs',
				},
				document:  {
					icon: 'fa fa-fw fa-file m-r-xs',
				},
			},
			version: 1,
		};

		$scope.events = {
			'ready':       $scope.readyEvent,
			'select_node': $scope.selectNodeEvent,
		};

		setupConditionalSelect($scope);
		setupContextMenu($scope);
		setupDragDrop($scope);
	};

	const mapItemsToNodes = (items) => {
		let nodes = [];

		angular.forEach(items, (item) => {
			nodes.push({
				id:         item.id,
				text:       item.name,
				parent:     (item.parent) ? (item.parent) : (ROOT_NODE_PARENT_IDENTIFIER),
				type:       (item.children !== undefined) ? ('directory') : ('document'),
				state:      {
					opened: false,
				},
				__uiNodeId: nodes.length,
			});
		});

		return nodes;
	};

	const selectNode = ($scope, id) => {
		if ($scope.ready) {
			$scope.instance.jstree(true)
			      .deselect_all();

			$scope.instance.jstree(true)
			      .select_node(id);
		}
	};

	return {
		replace:                    true,
		template:                   view,
		scope:                      {
			instance:                '=?',
			refreshOnUpdate:         '=',
			data:                    '=',
			onNodeSelected:          '=',
			selectedNodeId:          '=',
			conditionalSelect:       '=',
			conditionalSelectType:   '=',
			contextMenu:             '=',
			contextMenuItems:        '=',
			dragDrop:                '=',
			onContextMenuItemAction: '=',
			onDragDrop:              '=',
		},
		controller: /* @ngInject */ ($scope) => {
			$scope.readyEvent = (event, instance) => {
				$scope.ready = true;

				if ($scope.selectedNodeId !== undefined) {
					selectNode($scope, $scope.selectedNodeId);
				}
			};

			$scope.selectNodeEvent = (event, details) => {
				const node = details.node;

				if ($scope.selectedNodeId !== undefined) {
					$scope.selectedNodeId = node.id;
				}

				if ($scope.onNodeSelected) {
					$scope.onNodeSelected(node.id);
				}
			};

			$scope.moveNodeEvent = (event, details) => {
				const node = details.node;

				const before = {
					parentDirectoryId: (details.old_parent === ROOT_NODE_PARENT_IDENTIFIER) ? (null) : (details.old_parent),
					position:          details.old_position,
				};

				const after = {
					parentDirectoryId: (details.parent === ROOT_NODE_PARENT_IDENTIFIER) ? (null) : (details.parent),
					position:          details.position,
				};

				if (before.parentDirectoryId !== after.parentDirectoryId) {
					if ($scope.dragDrop && $scope.onDragDrop) {
						$scope.onDragDrop(node.id, before, after);
					}
				}
			};

			setup($scope);

			$scope.$watch('data', (newValue) => {
				$scope.nodes = mapItemsToNodes(newValue);
			}, true);

			$scope.$watch('refreshOnUpdate', (newValue) => {
				$scope.nodes = mapItemsToNodes($scope.data);

				$scope.config.version++;
			});

			$scope.$watch('selectedNodeId', (newValue) => {
				if (newValue) {
					selectNode($scope, newValue);
				}
			});

			$scope.nodes = mapItemsToNodes($scope.data);
		},
		link:                       (scope, element, attrs) => {

		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/directoryTree/index.js